"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformTaxSummaryEntryResponeList = exports.transformTaxSummaryEntryRespone = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Money_1 = require("../Money");
function transformTaxSummaryEntryRespone(response) {
    return {
        taxName: response.tax_name,
        netTax: response.net_tax && (0, Money_1.transformMoneyParsedResponse)(response.net_tax),
        netTaxableAmount: response.net_taxable_amount && (0, Money_1.transformMoneyParsedResponse)(response.net_taxable_amount),
        taxCollected: response.tax_collected && (0, Money_1.transformMoneyParsedResponse)(response.tax_collected),
        taxPaid: response.tax_paid && (0, Money_1.transformMoneyParsedResponse)(response.tax_paid),
        taxableAmountCollected: response.taxable_amount_collected && (0, Money_1.transformMoneyParsedResponse)(response.taxable_amount_collected),
        taxableAmountPaid: response.taxable_amount_paid && (0, Money_1.transformMoneyParsedResponse)(response.taxable_amount_paid),
    };
}
exports.transformTaxSummaryEntryRespone = transformTaxSummaryEntryRespone;
function transformTaxSummaryEntryResponeList(data) {
    if (data && data.length > 0) {
        return data.map((child) => transformTaxSummaryEntryRespone(child));
    }
    else {
        return [];
    }
}
exports.transformTaxSummaryEntryResponeList = transformTaxSummaryEntryResponeList;
//# sourceMappingURL=TaxSummaryEntry.js.map